__turbopack_context__.v({
  "container": "style-module-scss-module__8odRaq__container",
  "meat": "style-module-scss-module__8odRaq__meat",
  "meat1": "style-module-scss-module__8odRaq__meat1",
  "meat2": "style-module-scss-module__8odRaq__meat2",
  "meat3": "style-module-scss-module__8odRaq__meat3",
  "openMenu": "style-module-scss-module__8odRaq__openMenu",
});
